// import { encryption } from '../utils/functions/encryption';
import { encryption } from '../cryptography/encrypt';
import api from './api';

export async function geraChave(matricula, token) {
  const response = await api.get('GeraChave', {
    params: { matricula, token },
  });
  if (response?.data[0]?.Chave) {
    return { success: true, data: response?.data[0]?.Chave };
  }
  return { success: false, error: '' };
}

export async function ativaSessao(matricula, token) {
  const response = await api
    .post('AtivaSessao', {
      matricula,
      token,
      ip: '123',
      aplicacao: 'app',
    })
    .then((res) => {
      if (res.data[0].linhasafetadas === 1) {
        return true;
      }
      return false;
    })
    .catch((error) => {
      console.log('=>error --->', error);
      return false;
    });
  return response;
}

export async function validaLogin(matricula, senha, token) {
  const chave = await geraChave(matricula, token);
  if (!chave.success) {
    return {
      success: false,
      data: '',
      error: 'Erro não identificado. Entre em contato com a Forluz.',
    };
  }
  const cryptoPassword = await encryption({ chave: chave.data, senha });

  const response = await api
    .post('AutenticaUsuario', {
      matricula,
      senha: cryptoPassword,
    })
    .then(async (res) => {
      if (res.data[0] !== undefined && res.data[0].linhasafetadas === 1) {
        const retAtivaSessao = await ativaSessao(matricula, res.data[0].token);
        if (retAtivaSessao === true) {
          return { success: true, data: res.data[0] };
        }
        return {
          success: false,
          data: '',
          error: 'Usuario ou senha inválidos.',
        };
      }
      return {
        success: false,
        data: '',
        error: 'Usuario ou senha inválidos.',
      };
    })
    .catch((err) => {
      return { success: false, data: '', error: err };
    });
  return response;
}

export async function recuperaSenha(matricula) {
  const response = await api.get('AutenticaUsuario2Fatores', {
    params: { matricula },
  });

  return response.data[0];
}

export async function alteraSenha(matricula, token, password) {
  const chave = await geraChave(matricula, token);

  const data = { chave: chave.data, senha: password };
  const cryptoPassword = await encryption(data);

  const response = await api
    .post('AtualizaSenha', {
      matricula,
      token,
      senha: cryptoPassword,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return response.data[0];
}

export async function verificaManutencao() {
  const response = await api.get('VerificarManuntencao');

  return response.data;
}
